/**
 * Sidebar store using Zustand
 * Manages sidebar expanded/collapsed state globally
 */

import { create } from 'zustand';

interface SidebarStore {
  isExpanded: boolean;
  setExpanded: (expanded: boolean) => void;
  toggle: () => void;
}

export const useSidebarStore = create<SidebarStore>((set) => ({
  isExpanded: false,
  setExpanded: (expanded) => {
    set({ isExpanded: expanded });
  },
  toggle: () => {
    set((state) => ({ isExpanded: !state.isExpanded }));
  },
}));
